import { Fragment } from 'react'
import type { ReactNode } from 'react'
import { Dialog, Transition, TransitionChild } from '@headlessui/react'
import Image from 'next/image'

type Props = {
  isOpen: boolean
  isBackDropBlur?: boolean
  children: ReactNode
  onRequestClose?: () => void
  hideClosebutton?: boolean
}

const Modal = ({
  children,
  isOpen,
  isBackDropBlur = true,
  onRequestClose = () => null,
  hideClosebutton = false,
}: Props) => (
  <Transition appear show={isOpen} as={Fragment}>
    <Dialog
      open={isOpen}
      onClose={isBackDropBlur ? onRequestClose : () => null}
      className="relative z-50"
    >
      <div className="fixed inset-0 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center md:py-10">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/80 backdrop-blur-lg" aria-hidden="true" />
          </TransitionChild>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="pointer-events-auto relative mx-auto w-full max-w-4xl">
              {
                !hideClosebutton && (
                  <button
                    type="button"
                    className="absolute right-6 top-6 z-50 cursor-pointer"
                    onClick={onRequestClose}
                    aria-label="Close modal"
                  >
                    <Image
                      src="/images/feathericons/x-gray.svg"
                      alt="閉じる"
                      width={30}
                      height={30}
                    />
                  </button>
                )
              }
              <div className="bg-sheet rounded-lg text-left">
                {children}
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </Transition>
)

export default Modal
